<template>
  <b-sidebar
    id="userbodyhistorycalculate"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          محاسبه کالری
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <b-form
        class="p-2"
        @submit.prevent
      >

        <b-form-group
          label="جنسیت"
          label-for="Gender"
        >
          <v-select
            v-model="Form.Gender"
            dir="rtl"
            :reduce="x => x.value"
            label="text"
            input-id="Gender"
            :clearable="false"
            :options="enums('Gender')"
          />
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="وزن"
              label-for="Weight"
            >
              <cleave
                id="Weight"
                v-model="Form.Weight"
                class="form-control"
                :raw="false"
                :options="options"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="قد"
              label-for="Height"
            >
              <b-form-input
                id="Height"
                v-model="Form.Height"
                type="number"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="سن"
              label-for="Age"
            >
              <b-form-input
                id="Age"
                v-model="Form.Age"
                type="number"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="دور مچ"
              label-for="Wrist"
            >
              <b-form-input
                id="Wrist"
                v-model="Form.Wrist"
                type="number"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group
          label="وزن هدف"
          label-for="GoalWeight"
        >
          <b-form-input
            id="GoalWeight"
            v-model="Form.GoalWeight"
            type="number"
          />
        </b-form-group>

        <b-form-group
          label="میزان فعالیت"
          label-for="ActivityLevel"
        >
          <v-select
            v-model="Form.ActivityLevel"
            dir="rtl"
            :reduce="x => x.value"
            label="text"
            input-id="ActivityLevel"
            :clearable="false"
            :options="enums('ActivityLevel')"
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="calculate"
          >
            محاسبه
          </b-button>
        </div>

        <div
          v-if="Report != null"
          class="mt-2"
        >
          <hr class="mb-1">
          <div style="display: flex; justify-content: space-between;">
            <p>
              شاخص توده بدنی:
            </p>
            <p style="font-weight: 600;">
              {{ Report.BMI.toFixed(2) }}
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              وضعیت بدنی:
            </p>
            <p
              style="font-weight: 600;"
              class="text-warning"
            >
              {{ Report.BodyMass.Title }}
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              وزن سلامت:
            </p>
            <p style="font-weight: 600;">
              {{ Report.HealthWeight }} کیلوگرم
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              وزن مناسب:
            </p>
            <p style="font-weight: 600;">
              {{ Report.NormalWeight }} کیلوگرم
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              وزن زیبایی:
            </p>
            <p style="font-weight: 600;">
              {{ Report.BeautyWeight }} کیلوگرم
            </p>
          </div>
          <hr class="mb-1 mt-0">
          <div style="display: flex; justify-content: space-between;">
            <p>
              کالری روزانه با سرعت معمولی:
            </p>
            <p
              style="font-weight: 600;"
              class="text-primary"
            >
              {{ Report.FourKilosInMonth.Calorie }} کالری
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              تعداد روز با سرعت معمولی:
            </p>
            <p style="font-weight: 600;">
              {{ Report.FourKilosInMonth.Time }} روز
            </p>
          </div>
          <hr class="mb-1 mt-0">
          <div style="display: flex; justify-content: space-between;">
            <p>
              کالری روزانه با سرعت آهسته:
            </p>
            <p
              style="font-weight: 600;"
              class="text-primary"
            >
              {{ Report.TwoKilosInMonth.Calorie }} کالری
            </p>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p>
              تعداد روز با سرعت آهسته:
            </p>
            <p style="font-weight: 600;">
              {{ Report.TwoKilosInMonth.Time }} روز
            </p>
          </div>
        </div>

      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue'

export default {
  name: 'UserBodyHistoryCalculate',
  components: {
    BSidebar,
  },
  data() {
    return {
      Form: {
        Gender: 0,
        Weight: 75,
        GoalWeight: 65,
        Height: 170,
        Age: 25,
        Wrist: 16,
        ActivityLevel: 1,
      },
      Report: null,
      options: {
        numeral: true,
      },
    }
  },
  methods: {
    calculate() {
      this.Report = null
      this.$http.post(
        this.$api.user.userbodyhistorycalculate, this.Form,
      )
        .then(res => {
          this.Report = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style>

</style>
